import React from 'react';
import {Box, LinearProgress, Typography, useMediaQuery, useTheme} from "@material-ui/core";
import useStyles from "./StopoverWithExperiencesModalStyles";
import sataLogo from "../../../../../resources/images/sata-logo.svg";
import experiencesModal from "../../../../../resources/images/experiences-modal.png";
import azoresGetaways from "../../../../../resources/images/azores-getaways-logo.svg";
import {t} from 'ttag';
import {FullscreenDialog} from "../../../../index";

const StopoverWithExperiencesModal = () => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const classes = useStyles(isMobile);

    return (
        <FullscreenDialog PaperProps={{style: {backgroundColor: 'white'}}}>
            <Box className={classes.container} display={'flex'} flexDirection={'column'} justifyContent={'center'}
                 alignItems={'center'}>
                <Box className={[classes.sataImgContainer, classes.displayItems].join(' ')}>
                    <img
                        src={sataLogo}
                        alt={'Azores Airlines Logo'}
                    />
                </Box>
                <Box className={[classes.experiencesImgContainer, classes.displayItems].join(' ')}>
                    <img
                        className={classes.experiencesImg}
                        src={experiencesModal}
                        alt={'Stopover Experiences Modal'}
                    />
                    <LinearProgress className={classes.linearProgress} color={'secondary'}/>
                </Box>
                <Box className={[classes.containerTitle, classes.displayItems].join(' ')}>
                    <Typography className={classes.title} variant={'h6'} color={'primary'}>
                        {t`Just a moment please...`}
                    </Typography>
                    <Typography className={classes.subtitle} variant={'subtitle1'}>
                        {t`We are loading the best experiences in the Azores for the given dates`}
                    </Typography>
                </Box>
                <Box className={[classes.azoresGetawaysContainer, classes.displayItems].join(' ')}>
                    <Typography className={classes.subtitle} variant={'caption'}>
                        {t`IN PARTNERSHIP WITH`}
                    </Typography>
                    <img
                        src={azoresGetaways}
                        alt={'Azores Getaways Logo'}
                    />
                </Box>
            </Box>
        </FullscreenDialog>
    );
};

export default StopoverWithExperiencesModal;